import { Navigate, useParams } from "../../../../../router-utils"

export default function PGIntegrationItemDetailsPageIndex() {
	const { integrationId } = useParams("/integrations/:integrationId/pg")
	return (
		<Navigate
			to="/integrations/:integrationId/pg/transactions"
			params={{ integrationId }}
			replace
		/>
	)
}
